export const MARKER_TYPES = ['towns', 'activities', 'landmarks', 'restaurants',
	'stores', 'cafes', 'civic', 'bars', 'campgrounds', 'businesses', 'gas',
	'financial', 'lodging', 'churches', 'schools'];
